import { render, staticRenderFns } from "./addManual.vue?vue&type=template&id=729d7b54&scoped=true"
import script from "./addManual.vue?vue&type=script&lang=js"
export * from "./addManual.vue?vue&type=script&lang=js"
import style0 from "./addManual.vue?vue&type=style&index=0&id=729d7b54&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "729d7b54",
  null
  
)

export default component.exports